export const PASSWORD_POLICY_MESSAGE =
  "Use de 5 a 30 caracteres, incluindo ao menos uma letra maiúscula e um caractere especial.";

const getPasswordLength = (value = "") => Array.from(value).length;

export const isPasswordWithinPolicy = (value) => {
  if (typeof value !== "string") {
    return false;
  }

  const length = getPasswordLength(value);

  return (
    length >= 5 &&
    length <= 30 &&
    /[A-Z]/.test(value) &&
    /[^A-Za-z0-9]/.test(value)
  );
};

export const getPasswordStrength = (value) => {
  if (!isPasswordWithinPolicy(value)) {
    return null;
  }

  const length = getPasswordLength(value);

  if (length <= 9) return "FRACA";
  if (length <= 14) return "MEDIA";
  return "FORTE";
};
